import { ApiService } from '@/api';
import { UserStatus } from '@/models';

export class UsersApi {
  private readonly baseUrl = '/api/users';

  public async fetchCurrentUserStatus(): Promise<UserStatus> {
    const response =  await ApiService.get(`${this.baseUrl}/self/status`);

    return response.json();
  }

  public async fetchAppInsightsInstrumentationKey(): Promise<string> {
    const response =  await ApiService.get(`${this.baseUrl}/appInsights`);

    return response.text();
  }
}
